const mathHelper = {
  /**
   * Returns a random number in a provided range
   * @param {Number} min - The minimum number of the range
   * @param {Number} min - The maximum number of the range
   * @returns {Number} A random number in the provided range
   */
  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  },
};

export default mathHelper;
